import clsx from 'clsx';
import React from 'react'
import Spinner from './Spinner';

export type ButtonColors = null | "primary" | "secondary" | "warning" | "success" | "danger" | "accent" | "info"
type ColorMap = {
  [key in Exclude<ButtonColors, null>]: string
}

interface ownProps {
  color: ButtonColors,
  disabled?: boolean,
  loading?: boolean,
  children: React.ReactNode,
  className?: string,
  [key: string]: any,
}


const get_color = (color: ownProps["color"], disabled: boolean) => {
  const textcolor = disabled ? "text-gray-200" : "text-black";
  const DISABLED: ColorMap = {
    primary: "bg-primary/60",
    secondary: "bg-secondary/60",
    warning: "bg-warning/60",
    success: "bg-success/60",
    danger: "bg-danger/60",
    accent: "bg-accent/60",
    info: "bg-info/60",
  }
  const NORMALS: ColorMap = {
    primary: "bg-primary hover:bg-primary/80",
    secondary: "bg-secondary hover:bg-secondary/80",
    warning: "bg-warning hover:bg-warning/80",
    success: "bg-success hover:bg-success/80",
    danger: "bg-danger hover:bg-danger/80",
    accent: "bg-accent hover:bg-accent/80",
    info: "bg-info hover:bg-info/80",
  };
  if (color === null) return textcolor;

  const btncolor = disabled ? DISABLED[color] : NORMALS[color];

  return clsx(textcolor, btncolor);
}

const Button = ({ color, children, disabled = false, loading = false, className, ...props }: ownProps) => {
  return (
    <button
      disabled={disabled}
      className={clsx(
        "font-bold py-2 px-4 rounded-full transition inline-flex items-center gap-2",
        get_color(color, disabled),
        className,
      )} {...props} >
      {loading && <Spinner />}
      {children}
    </button>
  )
}

export default Button;
